import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export function NotFoundPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="mx-4 w-full max-w-lg rounded-2xl border border-slate-200 bg-white/90 p-8 text-center shadow-lg backdrop-blur">
        <div className="mb-6 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 animate-pulse rounded-full bg-red-100" />
            <svg className="relative h-16 w-16 text-red-500" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path
                d="M12 9v4m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>
        <h1 className="mb-2 text-4xl font-bold text-slate-900">{t('notFound.code')}</h1>
        <h2 className="mb-4 text-xl font-semibold text-slate-700">{t('notFound.title')}</h2>
        <p className="mb-8 leading-relaxed text-slate-600">{t('notFound.body')}</p>
        <button
          type="button"
          className="inline-flex items-center justify-center gap-2 rounded-xl bg-blue-600 px-6 py-2.5 text-white shadow-md transition hover:bg-blue-700"
          onClick={() => navigate('/')}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke="currentColor" strokeWidth="1.8" />
          </svg>
          {t('notFound.goHome')}
        </button>
      </div>
    </div>
  )
}
